import apiClient from "./apiClient";

function cleanFilters(filters = {}) {
  const sanitized = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (key === "minTotal" || key === "maxTotal" || key === "email") return;
    if (value === "" || value === null || value === undefined) return;
    sanitized[key] = value;
  });

  return sanitized;
}

const ghqAnalyticsApi = {
  getSummaryByCompanyAndMetric: async (companyId, metric, filters = {}) => {
    try {
      const response = await apiClient.get(`/analytics/ghq/${companyId}/${metric}`, {
        params: cleanFilters(filters)
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo analytics GHQ por métrica:", error);
      throw error;
    }
  },

  getSummaryGlobalByMetric: async (metric, filters = {}) => {
    try {
      const response = await apiClient.get(`/analytics/global/ghq/${metric}`, {
        params: cleanFilters(filters)
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo analytics GHQ global por métrica:", error);
      throw error;
    }
  }
};

export default ghqAnalyticsApi;
